export const INTEGRATION_TYPE = {
  NODIFI: 'nodifi',
};
